module.exports = __webpack_public_path__ + "static/media/no-matching.195e4964.png";